<template>
    <div class="changes-input">
        <label class="ci-label mb-0">
            Max changes
            <br>
            <input type="text" :value="value.changes" class="ci-input" @input="updateChanges">
        </label>
        <label class="ci-label mb-0">
            Extra change time (mins)
            <br>
            <input type="text" :value="value.time" class="ci-input" @input="updateTime">
        </label>
    </div>
</template>

<script>
    export default {
        name: 'ChangesInput',
        props: {
            value: {
                type: Object,
                default() {
                    return {
                        changes: null,
                        time: null,
                    };
                },
            },
            config: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        methods: {
            updateChanges(event) {
                this.$emit('input', {
                    changes: this.inputValueAsNullOrInteger(event.target.value),
                    time: this.value.time,
                });
            },
            updateTime(event) {
                this.$emit('input', {
                    changes: this.value.changes,
                    time: this.inputValueAsNullOrInteger(event.target.value),
                });
            },
            inputValueAsNullOrInteger(value) {
                if (value.length === 0) {
                    return null;
                }
                const numericValue = parseInt(value, 10);
                return Number.isNaN(numericValue) ? null : numericValue;
            },
        },
    };

</script>
